import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Button, ButtonGroup, Input, Label, FormGroup } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import { validateForm } from '../Constans/Validation';
import { INPUT_TYPE, PathHistory } from '../IdfSaleEnums';

import TextInput from '../../../Shared/TextInput/TextInput';
import AddressForm from '../../SaleJetBlock/Partials/AddressForm/AddressForm';
import PickUpCentersMain from './PickUpCenter/PickupCentersMain';
import TextArea from '../../../Shared/TextArea/TextArea';
import Buttons from '../Constans/Buttons';
import { GetPriceByPaymentCount } from '../IdfSaleSlice';
import { useDispatch } from 'react-redux';

export default function DeliveryDateStepOne(props) {
  const dispatch = useDispatch();
  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({
    deliverySelectedFirstName: false,
    deliverySelectedLastName: false,
    deliverySelectedPhoneNumber: false,
  });
  const store = props.idfStore;
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [deliveryNotes, setDeliveryNotes] = useState("");
  const [deliveryAdress, setDeliveryAdress] = useState(store.deliverySelectedAddress ?? null);
  const handleSelect = (center) => {
    setSelectedCenter(center === selectedCenter ? null : center);
  };
  const renderCount = useRef(0);
  const deliveryNotesRef = useRef();
  const getDeliveryPrice = async () => {
    const res = await dispatch(GetPriceByPaymentCount({ count: 1, itemId: 0, isLeasing: props.idfStore.isLeasing }));
    var price = res?.payload?.price?.toFixed();
    setDeliveryPrice(price);
  };
  useEffect(() => {
    if (store.deliveryMode == '') {
      props.setDeliveryMode('PICKUP')
    }
    getDeliveryPrice();
  }, []);

  useEffect(() => {
    renderCount.current++;
    if (store.isUsePersonalInfoAddress) {
      props.setDeliverySelectedAddress(store?.selectedAddres);
      if (renderCount.current > 1) {
        onContinueClick();
      }
    }
  }, [isSubmit]);

  const onSelectChange = (center) => { };


  const onContinueClick = async () => {
    if (store.deliveryMode === 'PICKUP') {
      if (selectedCenter) {
        props.setPickupServiceCenter(selectedCenter);
      } else {
        return false;
      }
    } else {
      var comment = deliveryNotes;
      if (store.isSimInMailBox) {
        comment = comment + ' השאירו את הסים בתיבה';
      }
      props.setDeliveryComments(comment);

      const isError = validateDeliveryForm();
      if (isError) {
        setIsSubmit(false);
        return false;
      } else {
        props.setCurrentStep({ current: PathHistory.DeliveryDateStep2, previous: store.steps.current });
        props.saveToHistory(PathHistory.DeliveryDateStep2)

      }
    }
    return true;
  };

  const validateDeliveryForm = () => {
    const formData = {
      deliverySelectedFirstName: {
        value: store.deliverySelectedFirstName,
        type: INPUT_TYPE.UNKNOWN,
      },
      deliverySelectedLastName: {
        value: store.deliverySelectedLastName,
        type: INPUT_TYPE.UNKNOWN,
      },
      deliverySelectedPhoneNumber: {
        value: store.deliverySelectedPhoneNumber,
        type: INPUT_TYPE.PHONE,
      },
    };

    const fieldsToValidate = Object.keys(formData);
    const errors = validateForm(formData, fieldsToValidate);
    setFormErrors(errors);

    return Object.values(errors).some((error) => error);
  };



  const onSubmit = async (data) => {
    setDeliveryAdress(data)
    if (data?.isValid) {
      props.setDeliverySelectedAddress(data);
      onContinueClick();
    }
    setIsSubmit(false);
  };
  return (
    <div className='delivery-date-main step'>
      <div className='idf-personal-info delivery-date-step-one step'>
        <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
          <Row className='idf-title-bold justify-content-center d-flex'>{props.contentData.deliveryTitle.value}</Row>
          <Row className='idf-line justify-content-center d-flex'></Row>
        </Container>

        <Container fluid className='address-container justify-content-center d-flex flex-column align-items-center'>
          <div className='address-header'>
            <Row className='idf-sub-title-bold justify-content-center d-flex'>איך תרצו לקבל את ההזמנה?</Row>
          </div>

          <div>
            <ButtonGroup>
              <Button outline onClick={() => props.setDeliveryMode('PICKUP')} active={store.deliveryMode === 'PICKUP'}>
                איסוף עצמי{' '}
              </Button>
              {store.selectedPhone?.paymentType !== 'OUTINVOICE' && (
                <Button outline onClick={() => props.setDeliveryMode('DELIVERY')} active={store.deliveryMode === 'DELIVERY'}>
                  משלוח{' '}
                </Button>
              )}
            </ButtonGroup>
          </div>
        </Container>

        <Container fluid className='address-container justify-content-center d-flex flex-column align-items-center'>
          {store.deliveryMode === 'DELIVERY' ? (
            <>
              <Row className='idf-free-delivery justify-content-center align-items-baseline d-flex mb-4'>
                <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M11.665 8.757c0 3.667 3.334 4.584 5 4.584v7.5c0 .416-5.833 1.666-7.5 1.666-1.333 0-2.222-.556-2.5-.833-.277-1.111-1.078-3.896-1.666-6.25-.834-3.334 2.5-2.917 4.166-2.917 0-1.111.084-3.5.417-4.166 1.25-1.25 1.667-.834 2.083.416z'
                    fill='#E0C1FF'
                  />
                  <path
                    d='M10.735 22.922H8.017a2.35 2.35 0 0 1-2.305-1.912l-1.007-3.662c-.896-2.558-.506-3.92-.02-4.612a2.019 2.019 0 0 1 1.694-.882h2.226a8.906 8.906 0 0 1 .093-2.776c.542-2.18 1.727-2.275 2.21-2.215.757.094 1.445.757 1.445 1.391a4.217 4.217 0 0 0 1.109 3.125c1.128 1.135 3.164 1.44 3.184 1.442a.565.565 0 0 1-.159 1.12c-.098-.013-2.43-.362-3.82-1.762a5.313 5.313 0 0 1-1.438-3.894.66.66 0 0 0-.531-.301c-.36.014-.7.526-.909 1.369-.286 1.154.007 2.956.01 2.974a.569.569 0 0 1-.126.46.561.561 0 0 1-.43.2H6.38a.9.9 0 0 0-.775.403c-.22.313-.644 1.291.168 3.6a.717.717 0 0 1 .012.038l1.019 3.703a.612.612 0 0 1 .01.05c.107.584.613 1.01 1.204 1.01h2.718c2.07 0 4.83-.465 5.428-1.085a.56.56 0 0 1 .795-.013.569.569 0 0 1 .013.8c-1.124 1.167-4.975 1.43-6.236 1.43z'
                    fill='var(--theme-primary, #810ea9)'
                  />
                  <path
                    d='M20.272 22.849h-3.706a.564.564 0 0 1-.562-.566v-9.635c0-.313.252-.566.562-.566h3.706c.31 0 .562.253.562.566v9.635a.564.564 0 0 1-.562.566z'
                    fill='var(--theme-primary, #810ea9)'
                  />
                  <path
                    d='M17.129 21.714h2.58V13.21h-2.58v8.503zM10.648 5.654a.564.564 0 0 1-.562-.566v-1.6c0-.313.252-.566.562-.566.31 0 .563.253.563.566v1.6a.564.564 0 0 1-.563.566zM13.547 7.31a.568.568 0 0 1-.29-1.051l1.362-.825a.56.56 0 0 1 .568-.017.566.566 0 0 1 .012.986l-1.362.826a.557.557 0 0 1-.29.08zM7.753 7.308a.557.557 0 0 1-.29-.08l-1.362-.826a.568.568 0 0 1-.184-.772.56.56 0 0 1 .764-.198l1.362.825a.568.568 0 0 1-.29 1.051z'
                    fill='var(--theme-primary, #810ea9)'
                  />
                </svg>

                {deliveryPrice === 0 ? <span> משלוח ללא עלות</span> : <span> משלוח בעלות {deliveryPrice} ₪</span>}
              </Row>

              <div style={isMobile ? { marginBottom: '16px' } : { marginBottom: '30px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Row className='idf-sub-title-bold m-auto '>לאן תרצו שהמשלוח יגיע? </Row>
                </div>
              </div>

              <div className='personal-address-input'>
                {store.selectedAddress != null && store.personalInfoMode == 'ADDRESS' && (
                  <FormGroup check inline>
                    <Input
                      className=''
                      dir='rtl'
                      type='checkbox'
                      defaultChecked={store.isUsePersonalInfoAddress}
                      onChange={(e) => props.setIsUsePersonalInfoAddress(e.target.checked)}
                    />
                    <Label check>מילוי אוטומטי לפי כתובת המנוי</Label>
                  </FormGroup>
                )}
              </div>
              <div className='address-form'>
                {store.isUsePersonalInfoAddress ? (
                  <div className='address-sale-block'>
                    <div className='address-wrapper '>
                      <TextInput
                        disabled={true}
                        className='mb-2'
                        value={store?.selectedAddress?.cityName}
                        placeholder='שם יישוב'
                        required='required'></TextInput>
                      <TextInput
                        disabled={true}
                        className='mb-2'
                        value={store?.selectedAddress?.streetName}
                        placeholder='רחוב'
                        required='required'></TextInput>
                      <TextInput
                        disabled={true}
                        className='mb-2'
                        value={store?.selectedAddress?.home}
                        placeholder='מספר בית'
                        required='required'></TextInput>
                      <div className='row-wrapper multiple-fields ' id='two-inputs-row'>
                        <TextInput
                          disabled={true}
                          className='mb-2'
                          value={store?.selectedAddress?.floor}
                          placeholder='קומה'
                          required='required'></TextInput>
                        <TextInput
                          disabled={true}
                          className='mb-2'
                          value={store?.selectedAddress?.apartment}
                          placeholder='דירה'
                          required='required'></TextInput>
                      </div>
                    </div>
                  </div>
                ) : (
                  <AddressForm onSubmit={onSubmit} isSubmit={isSubmit} selectedAddress={deliveryAdress} />
                )}

                <div className='delivery-inputs-container'>
                  <div style={{ marginBottom: '28px' }}>
                    <span className='idf-sub-title-bold  delivery-address-title'>מי יקבל את המשלוח?</span>
                  </div>
                  <div className='leave-sim-mailbox-container' style={{ marginBottom: '15px' }}>
                    {store.processType === 'SIM' && store.simType == "SIM" && (
                      <FormGroup check inline>
                        <Input
                          className=''
                          dir='rtl'
                          type='checkbox'
                          defaultChecked={store.isSimInMailBox}
                          onChange={(e) => props.setIsSimInMailBox(e.target.checked)}
                        />
                        <Label check>השאירו את הסים בתיבה</Label>
                      </FormGroup>
                    )}
                  </div>
                  <>
                    <div className='delivery-inputs'>
                      <TextInput
                        className={`mb-2 ${formErrors.deliverySelectedFirstName ? 'input-error' : ''} your-firstname-input-class`}
                        value={store?.deliverySelectedFirstName}
                        placeholder='שם פרטי'
                        required='required'
                        error={formErrors.deliverySelectedFirstName && 'יש להזין שם פרטי'}
                        onChange={(e) => props.setDeliverySelectedFullName({ value: e.target.value, target: 'FIRST-NAME' })}></TextInput>

                      <TextInput
                        className={`mb-2 ${formErrors.deliverySelectedLastName ? 'input-error' : ''} your-lastname-input-class`}
                        value={store?.deliverySelectedLastName}
                        placeholder='שם משפחה'
                        required='required'
                        error={formErrors.deliverySelectedLastName && 'יש להזין שם משפחה'}
                        onChange={(e) => props.setDeliverySelectedFullName({ value: e.target.value, target: 'LAST-NAME' })}></TextInput>

                      <TextInput
                        className={`mb-2 ${formErrors.deliverySelectedPhoneNumber ? 'input-error' : ''} your-phonenumber-input-class`}
                        value={store?.deliverySelectedPhoneNumber}
                        placeholder='טלפון נייד'
                        required='required'
                        error={formErrors.deliverySelectedPhoneNumber && 'יש להזין מספר טלפון'}
                        onChange={(e) => props.setDeliverySelectedPhoneNumber(e.target.value)}></TextInput>
                    </div>

                    <Row className='idf-sub-title' style={!isMobile ? { width: '440px' } : { width: 'unset' }}>
                      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M14.121 12.534c-.27.15-.415.448-.415.747v1.302l-4.159.341v-1.643a.882.882 0 0 0-.374-.747c-1.435-.854-2.1-2.135-2.1-3.885-.02-2.625 2.038-4.76 4.553-4.76 2.516 0 4.575 2.135 4.575 4.76-.021 1.708-.77 3.16-2.08 3.885z'
                          fill='#E0C1FF'
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M5.389 8.649c0-3.565 2.827-6.467 6.237-6.467s6.238 2.902 6.258 6.467c0 2.156-1.039 4.034-2.495 5.122v1.601c0 .448-.374.811-.81.854l-5.718.47h-.083a.842.842 0 0 1-.582-.235c-.167-.15-.312-.384-.312-.62V13.75c-1.664-1.174-2.495-2.924-2.495-5.101zm8.316 4.632c0-.299.146-.598.416-.747 1.31-.726 2.059-2.177 2.08-3.885 0-2.625-2.059-4.76-4.575-4.76S7.052 6.025 7.073 8.65c0 1.75.665 3.031 2.1 3.885.25.17.374.448.374.747v1.643l4.158-.341V13.28z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                        <path
                          d='m14.516 18.958-5.676.427h-.063c-.436 0-.79-.342-.832-.79a.851.851 0 0 1 .77-.918l5.676-.427a.82.82 0 0 1 .894.79.851.851 0 0 1-.77.918zM12.707 21.647l-2.038.17h-.062c-.437 0-.79-.34-.832-.789a.851.851 0 0 1 .77-.918l2.058-.17a.827.827 0 0 1 .873.79.851.851 0 0 1-.77.917zM14.931 8.627c-.041.384-.353.683-.727.683h-.063a.737.737 0 0 1-.644-.81c.125-1.217-.915-1.666-1.04-1.708a.776.776 0 0 1-.436-.96c.124-.385.54-.598.914-.45.77.278 2.184 1.324 1.996 3.245z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                      </svg>

                      <span>רק אדם מעל גיל 18 יכול לקבל את המשלוח</span>
                    </Row>
                  </>

                </div>
                <div className='delivery-comments'>
                  <div style={{ marginBottom: '28px', textAlign: 'center' }}>
                    <span className='idf-sub-title-bold delivery-address-title'>תרצו להוסיף הערה או בקשה לשליח?</span>
                  </div>
                  <TextArea
                    ref={deliveryNotesRef}
                    adj
                    maxLength={180}
                    className='mb-2'
                    value={deliveryNotes}
                    onChange={setDeliveryNotes}
                    placeholder='כתבו כאן הערה או בקשה לשליח'></TextArea>
                </div>
              </div>
            </>
          ) : (
            <Container id='idf-service-center-container'>
              <Row className='idf-sub-title m-0 mb-2 '></Row>
              <PickUpCentersMain
                handleSelect={handleSelect}
                selectedCenter={selectedCenter}
                GetCitiesServiceCenters={props.GetCitiesServiceCenters}></PickUpCentersMain>
            </Container>
          )}
        </Container>

        <Buttons
          onClickNavigation={onContinueClick}
          isForm={store.deliveryMode === 'DELIVERY'}
          setIsSubmit={setIsSubmit}
          canContinue={(store.deliveryMode === 'PICKUP' && selectedCenter != null) || store.deliveryMode === 'DELIVERY'}
        />
      </div>
    </div>

  );
}
